export default __webpack_public_path__ + "static/media/braintumor.a95082a0.jpg";